import { StyleSheet } from 'react-native';
import { fontFamilyRegular, linkColor } from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    marginLeft: 4,
    marginRight: 4,
    marginBottom: 5,
    marginTop: 5,
  },
  textStyle: {
    fontFamily: fontFamilyRegular,
    color: linkColor,
  },
});
